import { useState, useCallback, useEffect } from 'react';
import getNoImageFoundUrl from '../../tools/getNoImageFoundUrl';

function useImageManager(initialImageData, activeBrand = 'anf', isLoading = true, error = null) {
  const [imageData, setImageData] = useState(initialImageData);
  const isImageDataEmptyOrMissingMainSrc = (data) => !data || data.every((image) => !image.mainImageSrc);

  const handleImageErrorOrRemoval = useCallback((id = null) => {
    const noImageFoundUrl = getNoImageFoundUrl(activeBrand);

    setImageData((previousImageData) => {
      let updatedImages = previousImageData ? [...previousImageData] : [];

      if (id) {
        updatedImages = updatedImages.filter((image) => image.imageId !== id);
      }

      if (isImageDataEmptyOrMissingMainSrc(updatedImages)) {
        return [{
          imageId: 'no-image-placeholder',
          alt: 'no image found',
          mainImageSrc: noImageFoundUrl,
          type: 'prod',
        }];
      }
      return updatedImages;
    });
  }, [activeBrand]);

  useEffect(() => {
    if (!isLoading && !error && isImageDataEmptyOrMissingMainSrc(imageData)) {
      handleImageErrorOrRemoval();
    }
  }, [handleImageErrorOrRemoval, imageData, isLoading, error]);

  return {
    imageData,
    setImageData,
    handleImageErrorOrRemoval,
  };
}

export default useImageManager;
